import { Theme } from '@desygner/ui-common-components';
import { TranslationProvider } from '@desygner/ui-common-translation';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider as StoreProvider } from 'react-redux';
import { ThemeProvider } from 'styled-components';
import tinycolor from 'tinycolor2';
import { logError } from './logger';

import Store from '@store';

export default class ReactAppBuilder {
  initialized = false;

  constructor ({ appId, targetNodeSelector }) {
    this.appId = appId;
    this.targetNodeSelector = targetNodeSelector;
  }

  get theme () {
    const colors = INKIVE.C.WHITE_LABEL_CONFIGURATION.colors;

    return {
      ...Theme,
      Color: {
        ...Theme.Color,
        Brand: {
          ...Theme.Color.Brand,
          Lightest: tinycolor.mix('#FFFFFF', colors.highlight, 7).toHexString(),
          Light: tinycolor.mix('#FFFFFF', colors.highlight, 10).toHexString(),
          Primary: colors.highlight,
          Dark: tinycolor(colors.highlight).darken(10).toHexString()
        }
      }
    };
  }

  createDOMNode () {
    const container = document.getElementById(this.appId);
    if (container) return container;

    const targetNode = document.querySelector(this.targetNodeSelector);
    const app = document.createElement('div');
    app.id = this.appId;
    targetNode.appendChild(app);

    this.appNode = document.getElementById(app.id);
    return this.appNode;
  }

  async loadTranslation () {
    if (this.translation) return this.translation;

    const translation = await INKIVE.TranslateHelper.load();
    this.translation = {
      translationContent: translation,
      language: INKIVE.TranslateHelper.locale
    };

    return translation;
  }

  async mountApp (App) {
    await this.loadTranslation();

    if (this.root) return;

    this.root = createRoot(this.createDOMNode());

    this.root.render((
      <StoreProvider store={Store}>
        <ThemeProvider theme={this.theme}>
          <TranslationProvider {...this.translation}>
            <App />
          </TranslationProvider>
        </ThemeProvider>
      </StoreProvider>
    ));

    this.initialized = true;
  }

  closeApp () {
    try {
      if (!this.root) return;

      this.root.unmount();
      this.root = null;

      const container = document.getElementById(this.appId);
      if (container) container.remove();
    } catch (error) {
      logError('Error closing app', error);
    }
  }
}
